import logo from './logo.svg';
import './App.css';
import { ethers } from "ethers";
import React, { useState, useEffect } from 'react';

import './App.css'; // Make sure your CSS file is correctly imported


const contractAddress = "0xF4dF6ea7385796C4368437264495DAEb6e501838";
const contractABI = [{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"inputs":[],"name":"DigitsPad","outputs":[{"internalType":"contract IERC721","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address[]","name":"unstakers","type":"address[]"}],"name":"emergencyUnstake","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"staker","type":"address"}],"name":"getStakedInfo","outputs":[{"components":[{"internalType":"uint256[]","name":"tokens","type":"uint256[]"},{"internalType":"uint256","name":"endTime","type":"uint256"}],"internalType":"struct DigitsPadStaking.StakeInfo","name":"","type":"tuple"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"isStaked","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newInterface","type":"address"}],"name":"setDigitsPad","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256[]","name":"tokenIds","type":"uint256[]"}],"name":"stake","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"unstake","outputs":[],"stateMutability":"nonpayable","type":"function"}];

function App() {

  const [isConnected, setIsConnected] = useState(false);
  const [userAddress, setUserAddress] = useState('');
  const [nftIds, setNftIds] = useState([]);

  async function connectWallet() {
    if (typeof window.ethereum !== 'undefined') {
      try {
        const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
        const provider = new ethers.providers.Web3Provider(window.ethereum);

        setUserAddress(accounts[0]);
        setIsConnected(true);
        // Now you have access to the provider and can interact with contracts

        // const signer = provider.getSigner();
        const contract = new ethers.Contract(contractAddress, contractABI, provider);

        try {
          // Assuming 'getOwnedNFTs' is the function in your contract
          const ids = await contract.getStakedInfo(accounts[0]);
          console.log(ids)
          setNftIds(ids[0].map(id => id.toString()));
        } catch (error) {
          console.error('Error fetching NFT IDs:', error);
        }
      } catch (error) {
        console.error("User denied account access");
      }
    } else {
      console.log("MetaMask is not installed");
    }
  }


  async function interactWithContract() {
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const signer = provider.getSigner();
    const contract = new ethers.Contract(contractAddress, contractABI, signer);
  
    // Example: calling a function named 'myFunction' on your contract
    try {
      const transactionResponse = await contract.unstake();
      await transactionResponse.wait();
      // Function call was successful

      alert("Successful Unstake!");
    } catch (error) {
      console.error("Error:", error);
    }
  }


  return (
    <div className="app-container">
      <h1>Digits Pad Unstaking</h1>
      {!isConnected ? (
        <button onClick={connectWallet}>Connect Wallet</button>
      ) : (
        <div>
          <button onClick={interactWithContract}>Unstake</button>
          <div>
            <h3>My NFT Token IDs:</h3>
            <ul>
              {nftIds.length > 0 ? (
                nftIds.map((id, index) => <li key={index}>{id}</li>)
              ) : (
                <p>No NFTs found.</p>
              )}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
